// extracted by mini-css-extract-plugin
export default {"dlContainer":"styles_dlContainer__3HLvx","dropzoneText":"styles_dropzoneText__ZB2Pv","dropzoneSubText":"styles_dropzoneSubText__6cpEi"};